<div class="centered profile-menu-container">
  <div [matMenuTriggerFor]="profileMenu" class="centered avatar-name-container" aria-label="account">
    <mat-icon  fontIcon="{{ iconName }}"></mat-icon>
    <span class="user_name">{{username}}</span>
  </div>
  <mat-menu #profileMenu="matMenu">
    <div class="menu-identity" *ngIf="email">
      <span class="menu-identity__name">{{ username }}</span>
      <span class="menu-identity__email">{{ email }}</span>
    </div>
    <button  mat-menu-item [routerLink]="['/app/profile']">Profile</button>
    <button mat-menu-item (click)="logout()">Logout</button>
  </mat-menu>
  
</div>